import { createContext, useContext, useState, useEffect, useTransition } from 'react';

const LangContext = createContext({ lang: 'en', setLang: () => {} });

const RTL_LANGS = ['ar', 'ku'];

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('amko-lang') || 'en');
  const [, startTransition] = useTransition();

  const applyLang = l => {
    const isRtl = RTL_LANGS.includes(l);
    document.documentElement.setAttribute('dir',  isRtl ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', l);
    localStorage.setItem('amko-lang', l);
  };

  const setLang = l => {
    applyLang(l);
    startTransition(() => setLangState(l));
  };

  useEffect(() => { applyLang(lang); }, [lang]); // eslint-disable-line react-hooks/exhaustive-deps

  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
